

/**
 * Formats the distance from a date to now, removing "about " 
 * and changing "a day" to "1 day" as per user requirements.
 */
export const formatCustomDistanceToNow = (date: Date): string => {
	const now = new Date();
	const diffInSeconds = Math.floor((now.getTime() - date.getTime()) / 1000);

	if (diffInSeconds < 60) {
		return 'just now';
	}

	const diffInMinutes = Math.floor(diffInSeconds / 60);
	if (diffInMinutes < 60) {
		return `${diffInMinutes} min ago`;
	}

	const diffInHours = Math.floor(diffInMinutes / 60);
	if (diffInHours < 24) {
		return `${diffInHours} hr ago`;
	}

	const diffInDays = Math.floor(diffInHours / 24);
	return `${diffInDays} day ago`;
};
